import { Store } from 'vuex';
import { iUser } from '@/entities/user/user.types';
import serviceProvider from '@/services/service-provider';
import { ObjectLike } from '@/types/objectlike.types';
import { GetTextFunction } from '@/ui/types/i18n.types';
import { RootState } from '@/ui/store/types/root-module.types';
import { ToastyLike } from '@/ui/types/components.types';

const MODULE = 'general';

export type ShareReviewParameters = {
  $store: Store<RootState>;
  $refs: { [key: string]: Vue | Element | Vue[] | Element[] };
  reviewActionsVariables: ObjectLike;
  shareReviewVariables: ObjectLike;
  getText: GetTextFunction;
};

export default function useShareReviewFunctions({
  $store,
  $refs,
  reviewActionsVariables,
  shareReviewVariables,
  getText,
}: ShareReviewParameters) {
  async function share() {
    const storeUser: iUser = $store.getters['user/user'];
    const { reviewInstance } = reviewActionsVariables;
    const { shareClicked, toastyColor, toastyMessage } = shareReviewVariables;
    const toasty = $refs.toasty as Vue & ToastyLike;

    shareClicked.value = true;
    try {
      await serviceProvider.review.share(reviewInstance.value, storeUser.id, storeUser.gamertag);

      toastyColor.value = 'success';
      toastyMessage.value = getText(MODULE, 'Review.messages', 'shareSuccess');
      toasty.show();
      await $store.dispatch('feed/loadReviews');
    } catch (error) {
      toastyColor.value = 'error';
      toastyMessage.value = getText(MODULE, 'Review.messages', 'shareError');
      toasty.show();
    }

    shareClicked.value = false;
  }

  return {
    share,
  };
}
